module.exports = __webpack_public_path__ + "workspace/static/img/externalIDPOne.2ea86e7.png";